import { Controller } from "@hotwired/stimulus"
import Toastify from "toastify-js"

export default class extends Controller {
    connect() {
        const toastify = Toastify({
            className: `toastify--${this.type}`,
            text: this.message,
        })

        toastify.showToast()

        this.element.remove()
    }

    get title() {
        return this.data.get('title')
    }

    get duration() {
        return parseInt(this.data.get('duration'), 10) || 5000
    }

    get message() {
        return this.element.innerHTML
    }

    get type() {
        const type = this.data.get('type')

        return ['info', 'success', 'error'].includes(type) ? type : 'info';
    }
}
